function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 12.5v.833M15 16.667v.833M12.833 13.75l.75.417M16.417 15.833l.75.417M12.833 16.25l.75-.417M16.417 14.167l.75-.417M16.167 13.834c.666.666.666 1.666 0 2.333-.667.666-1.667.666-2.334 0-.666-.667-.666-1.667 0-2.334.667-.666 1.667-.666 2.334 0zM12.5 4.333c1.417 1.417 1.417 3.667 0 5-1.417 1.334-3.667 1.417-5 0-1.333-1.416-1.417-3.666 0-5a3.625 3.625 0 015 0zM3.333 16.667a3.734 3.734 0 013.75-3.75H9.25",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));